import "react-datepicker/dist/react-datepicker.css";


import { useEffect, useState } from "react";
import WarehouseService from "../../services/WarehouseService";
import DataTableManagers from "../../ui/DataTableManagers";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import DataTableProductWarehousePrices from "../../ui/DataTableProductWarehousePrices";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

const ProductsByPrices = ({ startLoading, stopLoading }) => {
  const [warehouseManagers, setWarehouseManagers] = useState([]);
  // total number of priced products, reported by the paginated table
  const [totalProducts, setTotalProducts] = useState(0);
  // const [warehouse, setWarehouse] = useState([]);
  const [nameWarehouse, setNameWarehouse] = useState("");
  const [deviseWarehouse, setDeviseWarehouse] = useState("");

  const [adressWarehouse, setAdressWarehouse] = useState("");

  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const [ca, setCa] = useState(0);
  const [achat, setAchat] = useState(0);
  const [refrech, setRefrech] = useState(false);

  useEffect(() => {
    startLoading()
    WarehouseService.getAllAchatAndCAWarehouseById(
      sessionStorage.getItem("idWarehouse")
    )
      .then((response) => {
        if (response.data["success"]) {
          console.log("response", response.data["success"]);
          setNameWarehouse(response.data["warehouse"])
          setWarehouseManagers(response.data["managers"]);
          setAdressWarehouse(response.data["adress"])
          setDeviseWarehouse(response.data["devise"])
        }

        if (response.data["ca"]) {
          setCa(response.data["ca"])
        }

        if (response.data["achat"]) {
          setAchat(response.data["achat"])
        }
      })
      .catch((e) => {
        console.log("error", e);
      }).finally(() => {
        stopLoading()
      })
  }, []);
  const onEditWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference,
    oldWarehouseManagerId
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      name: oldWarehouseName,
      description: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
      warehouseManagerId: oldWarehouseManagerId,
    };
    setOldWarehouseData(oldWarehouseData);
    setOnEditWarehouse(true);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          {sessionStorage.getItem("typeDocument") === "Warehouse" && (
            <><div className="row">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box bg-gray ">
                  <span className="info-box-icon">
                    <i class="fas fa-map-marker-alt mr-1"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Dépôt</span>
                    <span className="info-box-number">
                      {nameWarehouse}{" "}
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>

                    <span className="progress-description">
                      {adressWarehouse}
                    </span>
                  </div>
                </div>
              </div>

             

              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box  bg-black">
                  <span className="info-box-icon">
                    <i class="fas fa-shopping-cart"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Produits</span>

                    <span className="info-box-number">
                      {totalProducts}{" "}
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>
                    <span className="progress-description">
                      {totalProducts}
                    </span>
                  </div>
                </div>
              </div>
            </div>




              <div className="row">
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-money-bill-trend-up"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Chiffre d'affaire previsionnel (par pièce)</span>
                      <span className="info-box-number">
                        {ca}  {deviseWarehouse}
                      </span>
                      {/* <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>

                    <span className="progress-description">
                      
                    </span> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-money-bill-transfer"></i>                  </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Valeur de stock</span>
                      <span className="info-box-number">
                        {achat}  {deviseWarehouse}
                      </span>
                      {/* <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>

                    <span className="progress-description">
                      
                    </span> */}
                    </div>
                  </div>
                </div>
              </div>


            </>
          )}

          {/*<div className="row ">
            <div className="col-sm-12">
              {warehouseManagers && (
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Managers</h3>

                    <button
                      class="btn btn-dark float-right"
                      data-toggle="modal"
                      data-target="#edit-warehouse"
                      onClick={() =>
                        onEditWarehouseHandler(
                          warehouse.id,
                          warehouse.name,
                          warehouse.description,
                          warehouse.ref,
                          warehouse.warehouseManegerId
                        )
                      }
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                  <div className="card-body">
                    <DataTableManagers
                      listManagers={warehouseManagers}
                      idWarehouse={warehouse.id}
                    />
                  </div>
                </div>
              )}
            </div>  const [refrech, setRefrech] = useState(false);
            </div>*/}

          <div className="row ">
            <div className="col-sm-12">
              <DataTableProductWarehousePrices idWarehouse={sessionStorage.getItem("idWarehouse")} refrech={refrech} setRefrech={setRefrech} devise={deviseWarehouse} nameWarehouse={nameWarehouse} onTotalChange={setTotalProducts} />
            </div>
          </div>
        </div>
      </section>
      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
    </div>
  );
};
export default withLoader(ProductsByPrices);
